import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RolePermissionContainerComponent } from './role-permission-container.component';
import { RolePermissionListingComponent } from './role-permission-listing/role-permission-listing.component';
import { RolePermissionEditComponent } from './role-permission-edit/role-permission-edit.component';
import { RolePermissionTeamComponent } from './role-permission-edit/role-permission-team/role-permission-team.component';
import { RolePermissionSetComponent } from './role-permission-edit/role-permission-set/role-permission-set.component';
import { RolePermissionAddComponent } from './role-permission-add/role-permission-add.component';
import { RolePermissionUserComponent } from './role-permission-edit/role-permission-user/role-permission-user.component';
import { RolePermUserAddComponent } from './role-permission-edit/role-permission-user/role-perm-user-add/role-perm-user-add.component';
import { RolePermTeamAddComponent } from './role-permission-edit/role-permission-team/role-perm-team-add/role-perm-team-add.component';
import { RolePermissionSetAddListingComponent } from './role-permission-edit/role-permission-set/role-permission-set-add-listing/role-permission-set-add-listing.component';
import { RolePermissionDetailsComponent } from './role-permission-edit/role-permission-details/role-permission-details.component';
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';
import { ClientSidePermissionComponent } from './role-permission-edit/client-side-permission/client-side-permission.component';
import { AddRoleClientSidePermissionLinkComponent } from './role-permission-edit/client-side-permission/add/add.component';
import { EditRoleClientSidePermissionLinkComponent } from './role-permission-edit/client-side-permission/edit/edit.component';
import { PricingSchemeLinkComponent } from './role-permission-edit/pricing-scheme-link/pricing-scheme-link.component';
import { AddPricingSchemeLinkComponent } from './role-permission-edit/pricing-scheme-link/add-pricing-scheme-link/add-pricing-scheme-link.component';
import { EditPricingSchemeLinkComponent } from './role-permission-edit/pricing-scheme-link/edit-pricing-scheme-link/edit-pricing-scheme-link.component';
import { RolePermissionSetCopyFromComponent } from './role-permission-edit/role-permission-set-copy/role-permission-set-copy.component';

export const rolePermAgGridModule = AgGridModule.withComponents([]);

@NgModule({
  declarations: [
    RolePermissionContainerComponent,
    RolePermissionListingComponent,
    RolePermissionAddComponent,
    RolePermissionEditComponent,
    RolePermissionTeamComponent,
    RolePermissionSetComponent,
    RolePermissionUserComponent,
    RolePermUserAddComponent,
    RolePermTeamAddComponent,
    RolePermissionSetAddListingComponent,
    RolePermissionDetailsComponent,
    ClientSidePermissionComponent,
    AddRoleClientSidePermissionLinkComponent,
    EditRoleClientSidePermissionLinkComponent,
    PricingSchemeLinkComponent,
    AddPricingSchemeLinkComponent,
    EditPricingSchemeLinkComponent,
    RolePermissionSetCopyFromComponent,
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    rolePermAgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule
  ]
})
export class RolePermissionModule { }
